import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Variables d\'environnement Supabase manquantes (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY)');
}

// Nettoyer les anciennes sessions Supabase qui peuvent bloquer
const cleanupOldSessions = () => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.includes('supabase') || key.includes('sb-'))) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
};

// Nettoyer au démarrage pour éviter les sessions bloquantes
cleanupOldSessions();

// Configuration de Supabase sans persistance de session
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,  // Ne pas persister - évite le blocage au refresh
    autoRefreshToken: false
  }
});

// Fonction utilitaire pour forcer le nettoyage de la session
export const clearAuthSession = () => {
  cleanupOldSessions();
  window.location.reload();
};
